import React from "react";

const Footer = () => (
  <div className="mt-24">
    <p className="dark:text-gray-200 text-gray-700 text-center m-5">
      © 2025 Todos os direitos reservados a ZP Cosméticos
    </p>
    <p className="dark:text-gray-200 text-gray-700 text-center m-5 mb-5">
      v1.0.1
    </p>
  </div>
);

export default Footer;
